<template>
    <CCol md="5">
        <CCard class="p-4">
            <CCardBody>
                <CForm>
                    <CContainer>
                        <CRow>
                            <img
                                alt="Leadgrease logo"
                                class="mb-4"
                                src="@sset/leadgrease_black.png"
                            />
                        </CRow>
                        <CRow class="justify-content-center">
                            <p
                                class="text-center text-wrap"
                                style="font-size: 0.9em;color: blueviolet;width:72%;"
                            >
                                {{ $t("Check the activity of your panel, today begins a new day to draw conclusions") }}
                            </p>
                        </CRow>
                    </CContainer>

                    <CInput
                        type="email"
                        :lazy="false"
                        :value.sync="$v.form.email.$model"
                        :isValid="checkIfValid('email')"
                        :placeholder="`${$t('Email')}`"
                        autocomplete="email"
                        name="email"
                        :disabled="form._loading"
                    >
                        <template #prepend-content>
                            <CIcon name="cil-user" />
                        </template>
                    </CInput>
                    <CInput
                        :isValid="checkIfValid('password')"
                        :value.sync="$v.form.password.$model"
                        :placeholder="`${$t('Password')}`"
                        type="password"
                        name="password"
                        autocomplete="curent-password"
                        :disabled="form._loading"
                    >
                        <template #prepend-content>
                            <CIcon name="cil-lock-locked" />
                        </template>
                    </CInput>
                    <CRow>
                        <CCol col="12" class="text-right mb-2">
                            <CButton
                                color="link"
                                class="px-0 small"
                                @click="
                                    $router.push({ name: 'password.request' })
                                "
                            >
                                {{ $t("Forgot password") }}
                            </CButton>
                        </CCol>
                        <CCol col="12" class="text-left">
                            <CButton
                                block
                                color="primary"
                                type="submit"
                                class="px-4"
                                @click="login"
                                :disabled="form._loading"
                            >
                                <CSpinner
                                    class="mr-1"
                                    color="light"
                                    size="sm"
                                    v-if="form._loading"
                                />
                                {{ $t("Login") }}
                            </CButton>
                        </CCol>
                    </CRow>
                </CForm>
            </CCardBody>
        </CCard>
        <hr />
        <div class="small ml-auto my-auto">
            {{ $t("Dont have an account yet") }}
            <router-link :to="{ name: 'register' }" class="">
                {{ $t("Register now") }}
            </router-link>
        </div>
    </CCol>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { cilCheckCircle, cilWarning } from "@coreui/icons";

import pageMixin from "~/mixins/page.js";
export default {
    name: "LoginPage",

    mixins: [validationMixin, pageMixin],

    layout: "basic",

    middleware: "guest",

    icons: {
        cilCheckCircle,
        cilWarning
    },

    data: () => ({
        form: {
            email: "",
            password: "",
            _loading: false
        }
    }),

    computed: {
        isValid() {
            return !this.$v.form.$invalid;
        }
    },
    validations: {
        form: {
            email: {
                required,
                email
            },
            password: {
                required
            }
        }
    },

    methods: {
        checkIfValid(fieldName) {
            const field = this.$v.form[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },

        async login() {
            let url = "/";
            this.form._loading = true;
            const { status, data } = await this.sendForm({
                fetchConfig: {
                    baseURL: process.env.VUE_APP_API_AUTH,
                    url,
                    method: "POST",
                },
                customMessage: {
                    color: "success",
                    header: "¡_login!",
                    body: "login_successfully"
                }
            });

            this.form._loading = false;
            if (status) {
                console.log("Enter here");
                this.$store.dispatch("auth/saveToken", {
                    ...data,
                    email: this.form.email
                });
                this.$router.push({ name: "dashboard" });
            }
        },

        async sendForm({ formName , fetchConfig = {}, customMessage }) {

            let form = (formName)? this.forms[formName]: this.form;
            try {

                form._loading = true;

                let formData = {
                    ...form
                };

                /** If is form inValid not send */
                let isValid = await this.eventValidateForm(formName);
                if(!isValid){
                    return;
                }
                  
                delete formData._loading;

                if(this.eventBeforeSendForm){
                    formData = await this.eventBeforeSendForm(formData);
                }
                let data = await this.sendData({ 
                    url : fetchConfig.url, 
                    method: fetchConfig.method,
                    params: fetchConfig.params,
                    data:formData, 
                    config: fetchConfig
                });

                if(data.statusCode < 200 || data.statusCode >= 300){
                    throw new Error(data.message);
                }

                if(customMessage){
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...customMessage
                    });
                }else if(method == 'PUT'){
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.update
                    });
                }else{
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.create
                    });
                }

                form._loading = false;

                return {
                    status:true,
                    data
                }

            } catch (error) {
                this.showMessageError(error);
                form._loading = false;
                throw error;
            }
        },
        async sendData({ url, method, params, data, config }){

            // Replace params
            if(params){
                url = url.replace(/:([a-zA-Z0-9]+)/g, (match, key) => {
                    return params[key] || match;
                });
            }
            

            let fetchConfig = {
                ...config,
                url,
                method,
                data
            }

            try {
                const response = await axios(fetchConfig);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    }
};
</script>
